var _style, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.8,
    y1: 6.8,
    x2: 10.3,
    y2: 10.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    y1: 16,
    x2: 8,
    y2: 16
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.8,
    y1: 25.2,
    x2: 10.3,
    y2: 21.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 29,
    x2: 16,
    y2: 24
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25.2,
    y1: 25.2,
    x2: 21.7,
    y2: 21.7
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 29,
    y1: 16,
    x2: 24,
    y2: 16
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25.2,
    y1: 6.8,
    x2: 21.7,
    y2: 10.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.0f941a3dcfb42bb7a4c08f2fa783d636.svg";
export { ForwardRef as ReactComponent };